import {makeAutoObservable} from 'mobx';

import {UndoInfo, User, UserDetailed} from '@/domain';

class DiscoveryStore {
  users: UserDetailed[] = [];
  fetchedAllUsers = false;
  undoInfo: UndoInfo | null = null;
  filtersExtended: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  cleanUp() {
    this.users = [];
    this.fetchedAllUsers = false;
    this.filtersExtended = false;
  }

  getUserByIfd(id: number) {
    return this.users.find((user) => user.id === id);
  }

  setUsers(users: UserDetailed[]) {
    this.users = users;
  }

  addUsers(users: UserDetailed[]) {
    const existingUserIds = new Set(this.users.map((user) => user.id));
    const newUsers = users.filter((user) => !existingUserIds.has(user.id));
    this.users = [...this.users, ...newUsers];
  }

  prependUser(user: UserDetailed) {
    const existingUser = this.users.find((u) => u.id === user.id);

    if (existingUser) {
      return;
    }

    this.users = [user, ...this.users];
  }

  deleteUser(user: User) {
    this.users = this.users.filter((storedUser) => storedUser.id !== user.id);
  }

  setUserUndoInfo(undoInfo: UndoInfo | null) {
    this.undoInfo = undoInfo;
  }

  setFetchedAllUsers(fetched: boolean) {
    this.fetchedAllUsers = fetched;
  }

  setFiltersExtended(value: boolean) {
    this.filtersExtended = value;
  }
}

const discoveryStore = new DiscoveryStore();
export default discoveryStore;
